import React from "react";
import "./Privacy_policy.css"

const PrivacyPolicy = () => {
  return (
    <div className="container py-5 privacy-container">
      <h2 className="text-center mb-4">Privacy Policy of CEP (Cosmical Event Planners Private Limited)</h2>

<div className="privacy-section">
      <p >
        This privacy policy applies to your use of the CEP (Cosmical Event Planners Private Limited) website 
        located at <a href="https://www.cosmicalevents.in" target="_blank" rel="noopener noreferrer">www.cosmicalevents.in</a> 
        (hereafter referred to as "CEP" or "the Company").
      </p>

      <p>
        The terms <strong>"we," "us," and "CEP/the Company"</strong> refer to Cosmical Event Planners Private Limited. 
        The terms <strong>"you" and "your"</strong> refer to you, the user of the website.
      </p>

      <p>
        The term <strong>"personal information"</strong> means any information that you provide to us which personally 
        identifies you, such as your name, phone number, email address, and any other data that is tied to such 
        information.
      </p>

      <p>
        We reserve the right to revise or make changes to these Privacy Policies of CEP by updating this page. 
        Any revised policies will take effect immediately upon publication. We encourage users to review this 
        policy periodically to stay informed about our privacy practices.
      </p>
      </div>
      <div className="container py-5">

      {/* Introduction Section */}
      <section className="mb-4 privacy-section">
        <h4>1. Introduction</h4>
        <p>
          This privacy policy applies to your use of the CEP (Cosmical Event Planners Private Limited) website located at 
          <a href="https://www.cosmicalevents.in" target="_blank" rel="noopener noreferrer"> www.cosmicalevents.in</a> (hereafter referred to as "CEP" or "the Company").
        </p>
        <p>By using our website, you agree to the terms of this Privacy Policy.</p>
      </section>

      {/* Information We Collect and How We Use It */}
      <section className="mb-4 privacy-section">
        <h4>2. Information We Collect and How We Use It</h4>
        <p>
          This privacy policy explains how CEP collects, uses, and protects your personal information when you access and use our services. By accessing or using CEP, you agree to this policy.
        </p>

        <h5>a. Personal Information</h5>
        <p>
          When you register or use our services, we may ask for personal information such as your name, email address, phone number, location, and other details relevant to providing our services. We use this information to:
        </p>
        <ul>
          <li>Customize your experience and offer services that suit your preferences.</li>
          <li>Contact you with updates, newsletters, and other information about our services.</li>
          <li>Provide you with customer support and respond to queries or feedback.</li>
        </ul>

        <h5>b. Non-Personal Information</h5>
        <p>
          We automatically collect certain data when you use our services, such as:
        </p>
        <ul>
          <li>Your IP address, browser type, device information, and the date and time of your visit.</li>
          <li>Your activity on the platform, including the pages you visit and search queries.</li>
        </ul>
        <p>This data is used for statistical analysis, improving the website, and enhancing your experience.</p>

        <h5>c. Cookies and Similar Technologies</h5>
        <p>
          We use cookies to personalize and improve your experience. Cookies are small files stored on your device to remember your preferences and settings. You can control cookie settings through your browser, but disabling cookies may affect certain features of the website.
        </p>
      </section>

      {/* Transfer of Information */}
      <section className="mb-4 privacy-section">
        <h4>3. Transfer of Information</h4>
        <p>
          We may share your personal information in the following situations:
        </p>
        <ul>
          <li>With third-party vendors or affiliates who assist in providing our services (e.g., technical support, account management).</li>
          <li>In the event of a merger, acquisition, or sale of our assets, where your personal information may be transferred.</li>
          <li>If required by law, such as in response to legal requests, subpoenas, or to protect our rights and users.</li>
        </ul>
      </section>

      {/* User Rights */}
      <section className="mb-4 privacy-section">
        <h4>4. User Rights (GDPR & Other Regulations)</h4>
        <p>As a user, you have certain rights regarding your personal data:</p>
        <ul>
          <li><strong>Right to Access:</strong> You have the right to access the personal data we hold about you.</li>
          <li><strong>Right to Rectification:</strong> You may request corrections to any inaccurate or incomplete data.</li>
          <li><strong>Right to Deletion:</strong> You can request that we delete your personal data, subject to certain conditions.</li>
          <li><strong>Right to Restrict Processing:</strong> You can request restrictions on how we process your data.</li>
          <li><strong>Right to Data Portability:</strong> You can request a copy of your personal data in a structured, machine-readable format.</li>
          <li><strong>Right to Object:</strong> You can object to the processing of your data for specific purposes, including direct marketing.</li>
        </ul>
      </section>

      {/* Third-Party Links */}
      <section className="mb-4 privacy-section">
        <h4>5. Links to Third-Party Websites</h4>
        <p>
          Our platform may contain links to third-party websites that are not operated by us. We are not responsible for the privacy practices or content of these external sites. We encourage you to read the privacy policies of these third-party websites.
        </p>
      </section>

      {/* Security */}
      <section className="mb-4 privacy-section">
        <h4>6. Security</h4>
        <p>
          Your account is password-protected. We use industry-standard measures to protect the personal information stored in our database. We limit access to your data to authorized employees and contractors.
        </p>
        <p>
          While we take appropriate measures to safeguard against unauthorized disclosures, we cannot guarantee that your personal information will never be disclosed in a manner inconsistent with this Privacy Policy. By using CEP, you acknowledge that we are not responsible for intercepted information sent via the internet.
        </p>
      </section>

      {/* Control of Information */}
      <section className="mb-4 privacy-section">
        <h4>7. Control of Your Information</h4>
        <p>
          As a user, you can choose not to receive marketing communications or notifications by updating your preferences or unsubscribing from our communications.
        </p>
      </section>

      {/* Data Retention */}
      <section className="mb-4 privacy-section">
        <h4>8. Data Retention</h4>
        <p>
          We retain your personal data for as long as necessary to provide services, comply with legal obligations, resolve disputes, and enforce our agreements.
        </p>
      </section>

      {/* Consent */}
      <section className="mb-4 privacy-section">
        <h4>9. Consent</h4>
        <p>
          By using CEP, you consent to the collection, storage, and use of your information as outlined in this policy.
        </p>
      </section>

      {/* Modifications */}
      <section className="mb-4 privacy-section">
        <h4>10. Modifications to the Privacy Policy</h4>
        <p>
          We reserve the right to update this Privacy Policy periodically. Any changes will be posted on this page with the updated effective date. We recommend that you review this policy periodically.
        </p>
      </section>

      {/* Contact Information */}
      <section className="mb-4 privacy-section">
        <h4>11. Contact Information</h4>
        <p>
          If you have any questions or concerns about our privacy policy or wish to exercise your rights related to your personal data, please contact us at:
        </p>
        <p>Email: <a href="mailto:cepteam@cosmicalevents.in">cepteam@cosmicalevents.in</a></p>
        <p>Address: M/s. Cosmical Event Planners Private Limited, 131, Padmavat Colony B, Gopalpura Bypass, Shyam Nagar, Jaipur-302019</p>
      </section>

      {/* Jurisdiction */}
      <section className="mb-4 privacy-section">
        <h4>12. Jurisdiction and Governing Law</h4>
        <p>
          This Privacy Policy is governed by the laws of India. Any disputes will be resolved under the exclusive jurisdiction of the courts in Jaipur, Rajasthan.
        </p>
      </section>
    </div>
    <section className="mb-4 privacy-section">
        <h4>3. User Data Policy</h4>
        
        <h5>a. Data Points Collected for Users</h5>
        <p>
          The following data points are collected via **Meta Business Suite**, which provides access to our Facebook and Instagram accounts for login processes on our applications/website:
        </p>
        <ul>
          <li>Name of the user</li>
          <li>Email address</li>
          <li>Contact number</li>
        </ul>

        <h5>b. How and Where User Information Taken via Facebook/Instagram Login is Used</h5>
        <p>
          The data collected through Facebook/Instagram login is used for the following purposes:
        </p>
        <ul>
          <li>To authenticate users and provide a seamless login experience.</li>
          <li>To personalize user experience and improve the quality of our services.</li>
          <li>To provide customer support and address any user concerns.</li>
          <li>To send relevant updates, notifications, and promotional content (if the user has opted in).</li>
        </ul>
        <p>
          The data collected is securely stored and is not shared with unauthorized third parties.
        </p>
      </section>
      <table className="table table-bordered text-left privacy-table" style={{ width: "100%" }}>
        <thead>
          <tr>
            <th style={{ width: "50%", textAlign: "left" }}>Communication via Platforms like</th>
            <th style={{ width: "50%", textAlign: "left" }}>Analytics via Platforms like</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td  >
              <strong>Interakt:</strong> Sending out relevant and segmented marketing communications, 
              including mobile & web notifications, email marketing. Tracking & analyzing campaigns, 
              user properties, and user behavior to ensure correct and optimal communication.
            </td>
            <td style={{ backgroundColor: "#dbeafe" }} className="analytics-cell">
              <strong style={{ color: "#1d4ed8" }}>Google Ads:</strong> Tracks user traffic on the application (iOS and Android).
            </td>
          </tr>
          <tr>
            <td>
              <strong>AWS:</strong> Transactional email communication such as login OTPs, 
              and in-app/website transaction notifications sent & tracked.
            </td>
            <td>
              <strong>AWS:</strong> Our website is hosted on Amazon Cloud Server, and we abide by AWS policies and terms.
            </td>
          </tr>
          <tr>
            <td>
              <strong>Interakt:</strong> Used for triggering WhatsApp notifications to relevant users.
            </td>
            <td>
              <strong>Google Analytics:</strong> Tracks user traffic from different sources and runs ad campaigns via Google Ads.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    
  );
};

export default PrivacyPolicy;

  
